import * as React from 'react';

import config from 'js/app/config';

import type { Domain } from 'bundles/enterprise-legacy-learner-home/types/xdpTypes';
import { KEYWORD_IDS, getBreadcrumbSchema, getSchemaMarkupElement } from 'bundles/seo/utils/schemaMarkupUtils';

type InputProps = {
  domain?: Domain;
};

type Props = InputProps;

export function CoursePageBreadcrumbSchemaMarkup({ domain }: Props): JSX.Element | null {
  const keywordId = KEYWORD_IDS.COURSE;

  const breadcrumbType = getBreadcrumbSchema(domain, keywordId, config.url.domain);
  const graph = [breadcrumbType];

  return <div>{getSchemaMarkupElement(graph)}</div>;
}

export default CoursePageBreadcrumbSchemaMarkup;
